import { render, staticRenderFns } from "./PanelCloneArbo.vue?vue&type=template&id=a6e28144&"
import script from "./PanelCloneArbo.vue?vue&type=script&lang=js&"
export * from "./PanelCloneArbo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports